/** @jsx jsx */
import { jsx, Grid, Flex } from 'theme-ui'
import useSWR from 'swr'
import Reviews from './Reviews'
import { experiments, useExperiment } from '~/hooks/utils/use-experiment'

const Wrapper = ({
  showReadReviews,
  showTotalReviews,
  forwardSx,
  children,
}) => {
  const collectionsCardsTest = useExperiment(experiments.newProductCardLayout)

  return (
    <Flex sx={{
      justifyContent: 'center',
      alignItems: 'center',
      gap: ['4px', '8px'],
      ...forwardSx,
    }}>
      {children}
    </Flex>
  );

  /*return collectionsCardsTest ? (
    <Flex
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        gap: ['4px', '8px'],
        ...forwardSx,
      }}
    >
      {children}
    </Flex>
  ) : (
    <Grid
      sx={{
        justifyItems: 'center',
        gridAutoFlow: showReadReviews && !showTotalReviews ? 'column' : 'row',
        gridGap: '0.625rem',
        ...forwardSx,
      }}
    >
      {children}
    </Grid>
  )*/
}

const StarRating = ({
  product,
  forwardSx = {},
  color,
  showTotalReviews = true,
  showReadReviews = false,
}) => {
  const fetcher = url => fetch(url).then(r => r.json())

  const { data } = useSWR(
    `https://api.yotpo.com/products/${process.env.GATSBY_YOTPO_APP_KEY}/${product.yotpoId}/bottomline`,
    fetcher,
  )

  const productReviews = {
    averageScore: data?.response?.bottomline?.average_score,
    totalReviews: data?.response?.bottomline?.total_reviews,
  }
  const totalStars = 5

  const { averageScore, totalReviews } = productReviews

  return (
    <Wrapper
      forwardSx={forwardSx}
      showReadReviews={showReadReviews}
      showTotalReviews={showTotalReviews}
    >
      {!productReviews.totalReviews || !productReviews.averageScore ? (
        <Reviews
          color={color}
          averageScore={0}
          totalReviews={0}
          showReadReviews={showReadReviews}
          showTotalReviews={showTotalReviews}
          totalStars={totalStars}
        />
      ) : (
        <Reviews
          color={color}
          averageScore={averageScore}
          totalReviews={totalReviews}
          showReadReviews={showReadReviews}
          showTotalReviews={showTotalReviews}
          totalStars={totalStars}
        />
      )}
    </Wrapper>
  )
}

export default StarRating
